import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AppButton from "./AppButton";

// Mapping of IDs to labels
const userGroupMapping = {
  101: "Admin",
  102: "Field",
  103: "Headquarter",
  104: "Dealer",
};

// Function to map IDs to labels
const mapUserGroups = (groups) => {
  return groups
    .map((group) => userGroupMapping[group.userGroupId] || group.userGroupId) // Map ID to label or fallback to ID
    .join(", ");
};

// Helper function to extract required fields
const extractFields = (data) => {
  return data.map((item) => ({
    Email: item.emailAddress,
    UserType: item.userType,
    Persona: mapUserGroups(item.userGroup), // Apply mapping to user group
    Role: item.rlType.map((role) => role.RLtypename).join(", "), // Join multiple types if any
    "Assigned By":item.createdBy
  }));
};

const Exportuserlist = ({ excelData, fileName, title }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
  const fileExtension = ".xlsx";

  const exportTOExcel = async () => {
    const transformedData = extractFields(excelData);
    const ws = XLSX.utils.json_to_sheet(transformedData);

    // Apply column widths dynamically or statically
    const wscols = [
      { wch: 30 }, // email
      { wch: 15 }, // userType
      { wch: 25 }, // userGroup
      { wch: 20 }, // rlType
    ];
    ws["!cols"] = wscols;

    // Create workbook and export
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };


  return (
    <div>
     
        <AppButton onClick={exportTOExcel}  variant="fill"  title="Export" icon={<FileDownloadIcon/>} >Export Data</AppButton>

    </div>
  );
};

export default Exportuserlist;
